/* Approved templates only. Empty templates mean no product proposal, not a fallback. */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.ScarlatMixEngine = api;
})(typeof window !== 'undefined' ? window : globalThis, function () {
  'use strict';
  function add(map, key, quantity) { if (key) map[key] = (map[key] || 0) + quantity; }
  function summarize(items, total) {
    var result = { total: total || 0, pieces: 0, models: 0, categories: {}, roles: {}, positions: {}, finishes: {} };
    var models = new Set();
    items.forEach(function (item) {
      var q = Number(item.quantity), d = item.intelligence || {};
      result.pieces += q;
      models.add(String(item.product_id || item.productId));
      add(result.categories, d.category || 'Sem categoria informada', q);
      add(result.roles, d.role, q); add(result.positions, d.position, q); add(result.finishes, d.finish, q);
    });
    result.models = models.size;
    return result;
  }
  function evaluate(template, catalog, products) {
    if (!template || template.approved !== true || !Array.isArray(template.items) || !template.items.length) return null;
    if ([800, 1500, 5000].indexOf(Number(template.budget)) === -1) return null;
    var items = [], total = 0, seen = new Set();
    for (var line of template.items) {
      var d = catalog[String(line.sku)], quantity = Number(line.quantity);
      if (!d || !Number.isSafeInteger(quantity) || quantity < 1) return null;
      if (seen.has(String(line.sku))) return null;
      seen.add(String(line.sku));
      var product = products[d.handle];
      if (!product) return null;
      var variant = product.variants.find(function (v) { return String(v.id) === String(d.variantId); });
      if (!variant && !d.variantId && product.variants.length === 1) variant = product.variants[0];
      if (!variant || !variant.available) return null;
      var selectedData = d.variants && d.variants[String(variant.id)] || d;
      items.push({ sku: line.sku, quantity: quantity, variant_id: variant.id, product_id: product.id, intelligence: selectedData, price: variant.price });
      total += variant.price * quantity;
    }
    return { id: template.id, title: template.title, budget: template.budget, preferences: template.preferences || {}, items: items, summary: summarize(items, total) };
  }
  function rank(templates, answers) {
    return templates.filter(function (t) { return Number(t.budget) === Number(answers.budget); }).map(function (t, index) {
      var score = 0;
      ['moment', 'position'].forEach(function (key) {
        var values = t.preferences[key] || [];
        if (Array.isArray(values) && values.indexOf(answers[key]) !== -1) score += 1;
      });
      return { template: t, score: score, index: index };
    }).sort(function (a, b) { return b.score - a.score || a.index - b.index; }).map(function (v) { return v.template; });
  }
  function opportunities(items) {
    var presentProducts = new Set(items.map(function (i) { return String(i.product_id); }));
    var candidates = [], seen = new Set();
    items.forEach(function (item) {
      var matrix = item.pairs || {};
      var pairs = matrix.variants && matrix.variants[String(item.variant_id)] || matrix.items || [];
      pairs.forEach(function (pair) {
        if (!presentProducts.has(String(pair.productId))) candidates.push(Object.assign({}, pair, {
          sourceSilver: item.is_silver,
          sourceProductId: String(item.product_id), sourceTitle: item.title,
          sourceHandle: item.handle || '', sourceVariantId: String(item.variant_id), sourceSku: item.sku,
          targetProductId: String(pair.productId), targetSku: pair.sku || '',
          source_type: 'PAIR', reason_code: pair.reason_code || 'APPROVED_PAIR',
          algorithm_version: 'scarlat-v2-incremental.2026-10-07'
        }));
      });
    });
    return candidates.sort(function (a, b) { return a.priority - b.priority; }).filter(function (pair) {
      if (seen.has(String(pair.productId))) return false;
      seen.add(String(pair.productId)); return true;
    });
  }
  return { summarize: summarize, evaluate: evaluate, rank: rank, opportunities: opportunities };
});
